module.exports = __webpack_public_path__ + "img/icon-move-down.d5c25b6e.svg";